import axios from "axios";
import React from "react";
import Upload from "./Components/Upload";
/*
EMAILS
'mail.google.com', 
'outlook.office.com',
'mail.protonmail.com',
mail.superhuman.com


FILE
'drive.google.com',
'file://'

if application/pdf 

if it's not a url & is on iOS?

NOTION
- Check notion-body in HTML


OTHER
'google.com/search', 
'twitter.com/',
'getpocket.com/read', 
'play.pocketcasts.com', 
'app.slack.com', 
'facebook.com',
'news.ycombinator.com'
*/

function isSupportedType(article_url, user_id) {
  // console.log("userid", user_id)
  if (article_url === undefined) return null;

  const clean_up_url = (article_url) => {
    let article_id = article_url;
    if (article_url.startsWith("https://www."))
      article_id = article_url.replace("https://www.", "");
    if (article_url.startsWith("http://www."))
      article_id = article_url.replace("http://www.", "");
    if (article_url.startsWith("https://"))
      article_id = article_url.replace("https://", "");
    if (article_url.startsWith("http://"))
      article_id = article_url.replace("http://", "");
    return article_id;
  };

  const article_id = clean_up_url(article_url);

  if (article_id === undefined) return null;
  // console.log(article_url);
  // axios
  //   .get(article_url, {
  //     headers: {
  //       "Access-Control-Allow-Origin": "*",
  //     },
  //   })
  //   .then((res) => {
  //     console.log(res.headers["content-type"]);
  //     console.log(res);
  //     console.log(res.data);
  //   })
  //   .catch((e) => {
  //     console.log(e);
  //   });

  //   Check if it's email
  if (
    article_id.startsWith("mail.") ||
    article_id.startsWith("outlook.office.com") 
  ) {
    if (user_id) {
      return (
        <div>
          <div>Forward emails to {`user-${user_id}@email.audioread.com`}</div>
          {/* <div>
            Or highlight the text you want and right-click (on desktop) or tap
            Share (on mobile)
          </div> */}
        </div>
      );
    }
  } else if (article_id.startsWith("getpocket.com/read")) {
    return <div>Click "View Original" and send the original article</div>;
  } else if (
    article_id.startsWith("drive.google.com") ||
    article_id.startsWith("file://") 
    // ||article_id.includes(".pdf")
  ) {
    return (
      <div>
        Please close this popup, click "Upload PDF," and upload the file.
      </div>
    );
  } else if (article_id.startsWith("web.whatsapp.com")) {
    return (
      <div>
        Please highlight the message and right-click on desktop or click Share
        on mobile to convert.
      </div>
    );
  } else if (
    article_id.startsWith("docs.google.com") ||
    article_id.startsWith("onedrive.live.com")
  ) {
    return (
      <div>
        <div>Please manually upload the file or paste the text.</div>
      </div>
    );
  }

  // Check if it's a file
  // Check
}

export default isSupportedType;
